import { useState } from 'react';

const useToggle = initial => {
  const [open, setOpen] = useState(initial);

  return [
    open,
    newValue => setOpen(newValue !== undefined ? newValue : status => !status)
  ];
};

export default useToggle;
